import { CardFlat } from './CardFlat';

export type { TypeCardFlatProps } from './types';
export default CardFlat;
